import { inject, Injectable } from "@angular/core";
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpHeaders,
    HttpErrorResponse,
    HttpInterceptorFn,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { AppTokenHandler, HTTPStatus } from "src/app/Common/app-token-handler";
import { catchError, finalize } from "rxjs/operators";
import { Router } from "@angular/router";
// import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ProgressService } from "./progress.service";
import { NgxSpinnerService } from "ngx-spinner";

export const WinAuthInterceptor: HttpInterceptorFn = (req, next) => {
    const appToken = inject(AppTokenHandler);
    const route = inject(Router);
    const progressService = inject(ProgressService);
    const spinnerService = inject(NgxSpinnerService);

    let pendingRequests = 0;
    const access_token_value = appToken.getSessionToken();

    pendingRequests++;
    spinnerService.show();
    progressService.ChangeProgressStatus(true);

    if (access_token_value != null) {
        const cloned_req = req.clone({
            headers: req.headers.set("access_token", access_token_value),
        });
        return next(cloned_req).pipe(
            catchError((err: HttpErrorResponse) => {
                console.log(err);
                if (err.status === 401) {
                    console.log(err);
                    route.navigate(["/error/1"]);
                    return;
                }
                if (err.status === 417) {
                    route.navigate(["/error/3"]);
                    return;
                }
                // const error = err.error.message || err.statusText;
                return throwError(err.statusText);
            }),
            finalize(() => {
                pendingRequests--;
                if (pendingRequests <= 0) {
                    spinnerService.hide();
                    progressService.ChangeProgressStatus(false);
                }
            })
        );
    } else {
        console.log("Access token is null WinAuthInterceptor");
        route.navigate(["/error/1"]);
    }
};